module.exports = __webpack_public_path__ + "static/media/mv.21345b63.svg";